import { connect } from 'react-redux'
import TableView from '../../../../common/containers/TableView'
import { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { callUserListGet, callUserDelete } from '../../actions/users'
import { Link, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'

let UserList = ({ setPageAttr, list, methods: { callUserListGet, callUserDelete } }) => {
    let [searchParams] = useSearchParams();
    const remove = (id) => {
        Swal.fire({
            title: 'Tem certeza que deseja deletar? Essa ação não poderá ser desfeita!',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then((result) => {
            if (result.isConfirmed) {
                callUserDelete(id, () => {
                    let pg = searchParams.get('pg')
                    pg = pg ? pg : 1
                    callUserListGet({}, pg)
                })
            }
        })
    }
    const headers = [
        {
            type: 'info',
            name: 'id',
            align: 'right',
            label: 'ID'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Perfil',
            custom: (a) => {
                switch (a.profile) {
                    case 'admin':
                        return <>Administrador</>
                    case 'customer':
                        return <>Cliente</>
                    case 'technician':
                        return <>Técnico</>
                    case 'monitoring':
                        return <>Monitoramento</>
                    default:
                        return <>-</>
                }
            }
        },
        {
            type: 'info',
            name: 'name',
            align: 'left',
            label: 'Nome'
        },
        {
            type: 'info',
            name: 'username',
            align: 'left',
            label: 'Nome de Usuário'
        },
        {
            type: 'datetime',
            name: 'createdAt',
            align: 'right',
            label: 'Cadastro'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Opções',
            custom: (a) => {
                return (
                    <>
                        <Link to={'/users/edit/' + a.id} className='btn btn-sm btn-primary'><i className='fas fa-edit'></i></Link>
                        <span className='btn btn-sm btn-danger ml-2' onClick={() => remove(a.id)}><i className='fas fa-trash'></i></span>
                    </>
                )
            }
        }
    ]

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callUserListGet({}, pg)
    }, [callUserListGet, searchParams])

    useEffect(() => {
        setPageAttr({
            title: 'Usuários',
            caption: 'Gestão dos dados do usuário',
            btns: [
                /* {
                    type: 'button',
                    class: 'btn-warning',
                    icon: 'fas fa-filter',
                    label: 'Filtrar',
                    click: ()=>{
        
                    }
                }, */
                {
                    type: 'link',
                    class: 'btn btn-primary',
                    icon: 'fas fa-plus',
                    label: 'Adicionar',
                    to: '/users/add'
                }
            ],
            tabs: [
                {
                    active: true,
                    to: '/users',
                    label: 'Informações'
                }
            ]
        })
    }, [setPageAttr])

    return (
        <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/users'} />
    )
}

const mapStateToProps = ({ register: { users: { list } } }) => ({
    list: list,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callUserListGet,
            callUserDelete
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(UserList)